module.exports = __webpack_public_path__ + "img/symbol_18.952918dd.png";